"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _every2 = _interopRequireDefault(require("lodash/every"));
var _debounce2 = _interopRequireDefault(require("lodash/debounce"));
var _get2 = _interopRequireDefault(require("lodash/get"));
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _localization = require("@lt/localization");
var _userflow = require("../../icons-react/userflow");
var _LabledInput = _interopRequireDefault(require("../LabledInput"));
var _InputGroup = _interopRequireDefault(require("../InputGroup"));
var _withFormat = require("../../hocs/withFormat");
var _utils = require("./utils");
var _withValidation = _interopRequireDefault(require("../../hocs/withValidation"));
var _constants = require("./constants");
var _Input = _interopRequireDefault(require("../Input"));
var _InputTooltip = _interopRequireDefault(require("./components/InputTooltip"));
var _excluded = ["onChange", "onValidationChanged", "isMobile", "defaultValue", "showPaymentIcon", "validateMIRCard", "TooltipFooter"]; // Icons:
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var PaymentCard = function PaymentCard(_ref) {
  var onChange = _ref.onChange,
    onValidationChanged = _ref.onValidationChanged,
    _ref$isMobile = _ref.isMobile,
    isMobile = _ref$isMobile === void 0 ? false : _ref$isMobile,
    _ref$defaultValue = _ref.defaultValue,
    defaultValue = _ref$defaultValue === void 0 ? null : _ref$defaultValue,
    _ref$showPaymentIcon = _ref.showPaymentIcon,
    showPaymentIcon = _ref$showPaymentIcon === void 0 ? true : _ref$showPaymentIcon,
    _ref$validateMIRCard = _ref.validateMIRCard,
    validateMIRCard = _ref$validateMIRCard === void 0 ? false : _ref$validateMIRCard,
    TooltipFooter = _ref.TooltipFooter,
    rest = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var _useTranslation = (0, _localization.useTranslation)(),
    t = _useTranslation.t;
  var _useState = (0, _react.useState)((0, _get2["default"])(defaultValue, 'number', '')),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    number = _useState2[0],
    setNumber = _useState2[1];
  var _useState3 = (0, _react.useState)((0, _get2["default"])(defaultValue, 'expMonth', '') + (0, _get2["default"])(defaultValue, 'expYear', '')),
    _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
    expDate = _useState4[0],
    setExpDate = _useState4[1];
  var _useState5 = (0, _react.useState)((0, _get2["default"])(defaultValue, 'cvv', '')),
    _useState6 = (0, _slicedToArray2["default"])(_useState5, 2),
    cvv = _useState6[0],
    setCvv = _useState6[1];
  var _useState7 = (0, _react.useState)(false),
    _useState8 = (0, _slicedToArray2["default"])(_useState7, 2),
    numberFocus = _useState8[0],
    setNumerFocus = _useState8[1];
  var debouncedOnChange = (0, _react.useCallback)((0, _debounce2["default"])(onChange, 150), [onChange]);
  var handleChange = (0, _react.useCallback)(function () {
    var _getExpirationValues = (0, _utils.getExpirationValues)(expDate),
      _getExpirationValues2 = (0, _slicedToArray2["default"])(_getExpirationValues, 2),
      expMonth = _getExpirationValues2[0],
      expYear = _getExpirationValues2[1];
    debouncedOnChange({
      number: number,
      expMonth: expMonth,
      expYear: expYear,
      cvv: cvv
    });
  }, [number, expDate, cvv]);
  (0, _react.useEffect)(handleChange, [number, expDate, cvv]);
  var handleExpDateAutocomplete = function handleExpDateAutocomplete(e) {
    var value = e.target.value;
    var _getExpirationValues3 = (0, _utils.getExpirationValues)(value),
      _getExpirationValues4 = (0, _slicedToArray2["default"])(_getExpirationValues3, 2),
      expMonth = _getExpirationValues4[0],
      expYear = _getExpirationValues4[1];
    setTimeout(function () {
      return setExpDate(expMonth + expYear);
    }, 0);
  };
  var validation = (0, _utils.validateCardFields)({
    expDate: expDate.replace('/', ''),
    number: number,
    cvv: cvv
  });
  if (onValidationChanged) {
    var isValid = (0, _every2["default"])(validation, function (v) {
      return v;
    });
    (0, _react.useEffect)(function () {
      onValidationChanged(isValid);
    }, [isValid]);
  }
  return /*#__PURE__*/_react["default"].createElement(StyledPaymentCard, (0, _extends2["default"])({
    isMobile: isMobile,
    "data-at-package-payment-card-form": true
  }, rest), /*#__PURE__*/_react["default"].createElement(StyledHeader, null, /*#__PURE__*/_react["default"].createElement(StyledCardTytle, null, t('checkout.payment.safe')), showPaymentIcon && /*#__PURE__*/_react["default"].createElement(StyledPaymentCardsIcon, null)), /*#__PURE__*/_react["default"].createElement(StyledText, null, _constants.WARRANCY_TEXT), /*#__PURE__*/_react["default"].createElement(FakeAutocompleteInput, {
    tabIndex: -1,
    autoComplete: _constants.CARD_FIELDS.EXP_DATE.autocomplete,
    value: expDate,
    onChange: handleExpDateAutocomplete
  }), /*#__PURE__*/_react["default"].createElement(_InputGroup["default"], null, /*#__PURE__*/_react["default"].createElement(_InputTooltip["default"], {
    show: validateMIRCard && (number === null || number === void 0 ? void 0 : number.startsWith('2')) && !numberFocus,
    text: _constants.MIR_TOOLTIP,
    TooltipFooter: TooltipFooter
  }, /*#__PURE__*/_react["default"].createElement(StyledCardNumberField, (0, _extends2["default"])({}, _constants.CARD_FIELDS.NUMBER, {
    variant: _Input["default"].VARIANTS.SECURE,
    value: number,
    onChange: setNumber,
    isValid: validation[_constants.CARD_FIELDS.NUMBER.id],
    onBlur: function onBlur() {
      return setNumerFocus(false);
    },
    onFocus: function onFocus() {
      return setNumerFocus(true);
    }
  }))), /*#__PURE__*/_react["default"].createElement(StyledCardDateField, (0, _extends2["default"])({}, _constants.CARD_FIELDS.EXP_DATE, {
    variant: _Input["default"].VARIANTS.SECURE,
    value: expDate,
    onChange: setExpDate,
    isValid: validation[_constants.CARD_FIELDS.EXP_DATE.id]
  })), /*#__PURE__*/_react["default"].createElement(StyledCvvField, (0, _extends2["default"])({
    "data-sentry-mask": true
  }, _constants.CARD_FIELDS.CVV, {
    variant: _Input["default"].VARIANTS.SECURE,
    value: cvv,
    onChange: setCvv,
    isValid: validation[_constants.CARD_FIELDS.CVV.id]
  }))));
};
var StyledLabledInput = (0, _styledComponents["default"])(_LabledInput["default"]).withConfig({
  displayName: "PaymentCard__StyledLabledInput",
  componentId: "sc-1ntcjlr-0"
})(["font-weight:500;", "{height:11px;}"], _LabledInput["default"].Label);
var CardNumberField = (0, _withValidation["default"])((0, _withFormat.withCardNumberFormat)(StyledLabledInput));
var NumberField = (0, _withValidation["default"])((0, _withFormat.withNumberFormat)(StyledLabledInput));
var CardDateField = (0, _withValidation["default"])((0, _withFormat.withCardDateFormat)(StyledLabledInput));
var FakeAutocompleteInput = _styledComponents["default"].input.withConfig({
  displayName: "PaymentCard__FakeAutocompleteInput",
  componentId: "sc-1ntcjlr-1"
})(["position:absolute;top:-10000px;width:0;height:0;"]);
var StyledPaymentCard = _styledComponents["default"].div.withConfig({
  displayName: "PaymentCard__StyledPaymentCard",
  componentId: "sc-1ntcjlr-2"
})(["--card-width:310px;--card-height:200px;--input-font-size:14px;", ";padding:10px;width:var(--card-width);height:var(--card-height);background:", ";border-radius:6px;", "{font-size:var(--input-font-size);}"], function (props) {
  return props.isMobile && (0, _styledComponents.css)(["--input-font-size:13px;--card-width:277px;--card-height:175px;"]);
}, function (props) {
  return props.theme.colors.white;
}, StyledLabledInput);
var StyledHeader = _styledComponents["default"].div.withConfig({
  displayName: "PaymentCard__StyledHeader",
  componentId: "sc-1ntcjlr-3"
})(["display:flex;align-items:center;justify-content:space-between;margin-bottom:5px;"]);
var StyledCardNumberField = (0, _styledComponents["default"])(CardNumberField).attrs({
  label: _localization.i18n.t('checkout.payment.cardNumber')
}).withConfig({
  displayName: "PaymentCard__StyledCardNumberField",
  componentId: "sc-1ntcjlr-4"
})(["flex-basis:165px;flex-grow:2;flex-shrink:0;"]);
var StyledCardDateField = (0, _styledComponents["default"])(CardDateField).attrs({
  label: _localization.i18n.t('checkout.payment.cardDate')
}).withConfig({
  displayName: "PaymentCard__StyledCardDateField",
  componentId: "sc-1ntcjlr-5"
})(["flex-basis:52px;flex-grow:1;flex-shrink:0;"]);
var StyledCvvIcon = (0, _styledComponents["default"])(_userflow.Cvv).withConfig({
  displayName: "PaymentCard__StyledCvvIcon",
  componentId: "sc-1ntcjlr-6"
})(["width:17px;height:11px;margin-left:2px;"]);
var CvvLabel = /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, "cvv", /*#__PURE__*/_react["default"].createElement(StyledCvvIcon, null));
var StyledCvvField = (0, _styledComponents["default"])(NumberField).attrs({
  label: CvvLabel
}).withConfig({
  displayName: "PaymentCard__StyledCvvField",
  componentId: "sc-1ntcjlr-7"
})(["flex-basis:42px;flex-grow:1;flex-shrink:0;"]);
var StyledCardTytle = _styledComponents["default"].div.withConfig({
  displayName: "PaymentCard__StyledCardTytle",
  componentId: "sc-1ntcjlr-8"
})(["display:flex;align-items:baseline;color:var(--black);font-size:14px;font-style:normal;font-weight:500;"]);
var StyledText = _styledComponents["default"].div.withConfig({
  displayName: "PaymentCard__StyledText",
  componentId: "sc-1ntcjlr-9"
})(["font-size:12px;color:", ";white-space:pre-line;margin-bottom:20px;"], function (props) {
  return props.theme.colors.greyLight;
});
var StyledPaymentCardsIcon = (0, _styledComponents["default"])(_userflow.PaymentCards).withConfig({
  displayName: "PaymentCard__StyledPaymentCardsIcon",
  componentId: "sc-1ntcjlr-10"
})(["width:100px;"]);
var _default = exports["default"] = /*#__PURE__*/_react["default"].memo(PaymentCard);